<span id="language-selector-label" class="visually-hidden">
  {{ "language.header" | translate }}
</span>

@if (displayAs === "list") {
  <div
    class="language-list"
    role="listbox"
    aria-labelledby="language-selector-label"
  >
    @for (option of options; track option.value) {
      <button
        type="button"
        role="option"
        id="{{ option.value }}"
        class="language-list-item"
        [class.selected]="option.value === selectedLanguageValue"
        [attr.aria-selected]="option.value === selectedLanguageValue"
        [attr.aria-label]="
          'language.aria.select' | translate: { value: option.label }
        "
        (click)="selectLanguage(option.value)"
      >
        @if (showFlags) {
          <img [src]="option.src" [alt]="option.label + ' flag'" />
        }
        <span>{{ option.label }}</span>
      </button>
    }
  </div>
}

@if (displayAs === "selector") {
  <form [formGroup]="languageForm" aria-labelledby="language-selector-label">
    <ng-select
      #languageSelect
      id="language-select"
      [items]="options"
      searchable="false"
      bindLabel="label"
      bindValue="value"
      formControlName="language"
      clearable="false"
      [class.secondary]="displayVariant === 'PRIMARY'"
      (open)="onOpen()"
      (close)="onClose()"
      [attr.aria-labelledby]="'language-selector-label'"
      class="language-selector"
    >
      <ng-template ng-label-tmp let-item="item">
        <div
          class="{{
            displayVariant === 'PRIMARY'
              ? 'w-[2.5rem] md:w-auto justify-end md:flex md:items-center md:gap-3'
              : 'flex items-center h-14 gap-3'
          }}"
        >

          @if (showFlags || displayVariant === "PRIMARY") {
            <img
              [src]="item.src"
              [alt]="item.label + ' flag'"
            />
          }
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index">
        <div
          class="{{
            displayVariant === 'PRIMARY'
              ? 'flex items-center gap-3 w-[12.85rem]'
              : 'flex items-center gap-3'
          }}"
          role="option"
          [attr.aria-selected]="
            item.value === languageForm.get('language')?.value
          "
        >
          @if (showFlags) {
            <img [src]="item.src" [alt]="item.label + ' flag'" />
          }
          <span>{{ item.label }}</span>
        </div>
      </ng-template>
    </ng-select>
  </form>
}
